import { render, staticRenderFns } from "./AddParticipantDialog.vue?vue&type=template&id=28dbe4ba&scoped=true"
import script from "./AddParticipantDialog.vue?vue&type=script&lang=js"
export * from "./AddParticipantDialog.vue?vue&type=script&lang=js"
import style0 from "./AddParticipantDialog.vue?vue&type=style&index=0&id=28dbe4ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28dbe4ba",
  null
  
)

export default component.exports